import { X } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

export type FilterChip = {
  key: string
  label: string
  value?: string
  removeLabel: string
  onRemove: () => void
}

export function FilterChips({ chips, className }: { chips: FilterChip[]; className?: string }) {
  if (chips.length === 0) {
    return null
  }

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {chips.map((chip) => (
        <span key={chip.key} className="inline-flex min-h-8 max-w-full items-center gap-1 rounded-full border border-border bg-background px-2.5 text-sm text-foreground">
          <span className="truncate">
            {chip.label}
            {chip.value ? <span className="font-medium"> {chip.value}</span> : null}
          </span>
          <button
            type="button"
            className="inline-flex size-5 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            onClick={chip.onRemove}
          >
            <X className="size-3.5" aria-hidden />
            <span className="sr-only">{chip.removeLabel}</span>
          </button>
        </span>
      ))}
    </div>
  )
}
